import type { RouteLocationNormalized } from 'vue-router'
import { useAuthStore } from '@/modules/auth/stores/useAuthStore'
import { logger } from '@/core/utils/logger'

/**
 * Authentication guard
 * Redirects unauthenticated users to login page for non-public routes
 */
export const authGuard = async (
  to: RouteLocationNormalized,
) => {
  try {
    const authStore = useAuthStore()

    // Skip auth check for public routes
    if (to.meta.public) {
      return true
    }

    // Prevent redirect loop - if going to login and not authenticated, allow it
    if (to.name === 'login') {
      return true
    }

    // Check authentication
    if (!authStore.isAuthenticated) {
      logger.warn('[AuthGuard] User not authenticated, redirecting to login')
      return { name: 'login' }
    }

    // User is authenticated, allow navigation
    return true
  } catch (error: unknown) {
    logger.error('[AuthGuard] Error in auth guard:', error)
    // On error, redirect to login to be safe
    return { name: 'login' }
  }
}
